import {
  Button,
  Image,
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Text,
} from '@modusign/design-system';

import howToFindDocumentId from '@app/assets/modal/how-to-find-documentId-modal/how-to-find-documentId.svg';

interface HelpModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function HelpModal({ isOpen, onClose }: HelpModalProps) {
  return (
    <Modal isOpen={isOpen} maxWidth={526} onClose={onClose}>
      <ModalTitle>문서 ID 확인 방법</ModalTitle>
      <ModalContent>
        <Text as="p" fontSize="md" fontWeight="regular" mb={6} textAlign="center">
          PDF 파일의 <Text color="textEmphasisBase">왼쪽 아래</Text>
          에서문서 ID를 확인할 수 있습니다.
          <br />
          숫자+영문 조합의 ID를 드래그 후 복사해 보세요.
        </Text>
        <Image alt="document id" src={howToFindDocumentId} />
      </ModalContent>
      <ModalFooter>
        <Button onClick={onClose}>확인</Button>
      </ModalFooter>
    </Modal>
  );
}
